import type { NextPage } from "next";

export interface IPageWithUser {}

const Home: NextPage<IPageWithUser> = (props) => {
  return (
    <main style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
      <h1 style={{ margin: 0, fontSize: 20 }}>MoneyTasks API</h1>
    </main>
  );
};

export default Home;
